export enum Steps {
  Create,
  EnterConsideration,
  Summary,
  Success,
}

export const stepLabels = {
  [Steps.Create]: 'Add realisation',
  [Steps.EnterConsideration]: 'Complete allocation',
  [Steps.Summary]: 'Approve transaction',
};
